import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="space-y-6 text-gray-700">
      {/* <h2 className="text-2xl font-bold mb-6">Terms and Conditions</h2> */}
      
      <section className="space-y-4">
        <h3 className="text-xl font-semibold">1. Acceptance of Terms</h3>
        <p className="text-gray-600">
          By accessing and signing up for this service, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not go ahead.
        </p>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">2. User Account</h3>
        <p className="text-gray-600">
          You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account. You must be at least 18 years of age to use this service.
        </p>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">3. Subscription and Payments</h3>
        <div className="space-y-2 text-gray-600">
          <p>Subscription fees are billed in advance on a monthly or yearly basis. All fees are non-refundable.</p>
          <p>You can cancel your subscription at any time, but you will not receive a refund for any unused portion of your subscription period.</p>
          <p>We reserve the right to modify subscription fees at any time. We will provide you with reasonable notice of any fee changes.</p>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">4. Content Usage</h3>
        <div className="space-y-2 text-gray-600">
          <p>You retain all rights to your uploaded content. By using our service, you grant us a license to process and store your content for the purpose of providing & improving our services.</p>
          <p>You are solely responsible for the content you upload and must ensure you have the necessary rights and permissions to use such content.</p>
          <p>We reserve the right to remove any content that violates these terms or is otherwise objectionable.</p>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">5. Privacy Policy</h3>
        <div className="space-y-2 text-gray-600">
          <p>Your use of our service is also governed by our Privacy Policy. Please review our Privacy Policy, which also governs the site and informs users of our data collection practices.</p>
          <p>We collect and process personal data in accordance with applicable data protection laws and our Privacy Policy.</p>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">6. Intellectual Property</h3>
        <div className="space-y-2 text-gray-600">
          <p>The service and its original content, features, and functionality are owned by us and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
          <p>You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our service.</p>
          <p>Our trademarks and trade dress may not be used in connection with any product or service without our prior written consent.</p>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">7. Limitation of Liability</h3>
        <div className="space-y-2 text-gray-600">
          <p>In no event shall we be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.</p>
          <p>Our liability to you for any damages arising from or related to this agreement will not exceed the amount you have paid us in the last one month.</p>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">8. Changes to Terms</h3>
        <div className="space-y-2 text-gray-600">
          <p>We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms and Conditions on this page.</p>
          <p>Your continued use of the service after any such changes constitutes your acceptance of the new Terms and Conditions.</p>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="text-xl font-semibold">9. Contact Information</h3>
        <div className="space-y-2 text-gray-600">
          <p>If you have any questions about these Terms, please contact us at:</p>
          <p>Email: hello@styleuai.com</p>
        </div>
      </section>

      <div className="mt-8 pt-6 border-t border-gray-200">
        <p className="text-sm text-gray-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions; 